
import { useStore } from '@/store'
import { defineComponent, computed, watch, ref, onMounted } from 'vue'
import threadSettings from '@/settings/thread-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import { ColorpickerActionTypes } from '@/store/modules/colorpicker/action-types'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'
import FormColorPicker from '@/components/Form/FormColorPicker.vue'
import StageDeterminerService from '@/services/page/stage-determiner.service'

export default defineComponent({
  name: 'FormThread',
  components: {
    FormScrollableTab,
    FormOption,
    FormColorPicker
  },
  props: {
    index: Number
  },
  setup() {
    let stageDeterminer = new StageDeterminerService()
    const store = useStore()
    const configName = ref('configThreadId')
    const colorpicker = ref("#2e2e2e")
    const showColorPicker = ref(false)
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => threadSettings.threadColors)

    onMounted(() => {
      if (stageDeterminer.isColorpickerVisible()) {
        showColorPicker.value = true
      }
    })

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_THREAD, option.id)
      Analytics.instance.sendThreadEvent(option.id)

      colorpicker.value = option.value || "#2e2e2e";
    }

    const onColorPickerUpdate = (val) => {
      store.dispatch(ColorpickerActionTypes.SET_COLORPICKER_THREAD, val)
    }

    return {
      config,
      configName,
      threadSettings,
      colorpicker,
      options,
      showColorPicker,
      onClick,
      onColorPickerUpdate
    }
  }
})
